var _clipPath, _polygon;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var SvgHexagon = function SvgHexagon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "300px",
    viewBox: "0 0 319 275"
  }, props), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-hexagon",
    clipPathUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "0.25 0, 0.75 0, 1 0.5, 0.75 0.98, 0.25 0.98, 0 0.5"
  }))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "80.75 2, 237.25 2, 316 140.5, 237.25 273, 80.75 273, 2 140.5"
  })));
};

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzAwcHgiIHZpZXdCb3g9IjAgMCAzMTkgMjc1IiB2ZXJzaW9uPSIxLjEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIKIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIj4KICA8Y2xpcFBhdGggaWQ9ImNsaXAtaGV4YWdvbiIgY2xpcFBhdGhVbml0cz0ib2JqZWN0Qm91bmRpbmdCb3giPgogICAgPHBvbHlnb24gcG9pbnRzPSIwLjI1IDAsIDAuNzUgMCwgMSAwLjUsIDAuNzUgMC45OCwgMC4yNSAwLjk4LCAwIDAuNSIgLz4KICA8L2NsaXBQYXRoPgogIDxwb2x5Z29uIHBvaW50cz0iODAuNzUgMiwgMjM3LjI1IDIsIDMxNiAxNDAuNSwgMjM3LjI1IDI3MywgODAuNzUgMjczLCAyIDE0MC41IiAvPgo8L3N2Zz4K";
export { SvgHexagon as ReactComponent };